// extracted by mini-css-extract-plugin
export default {"selected":"TableMobile__selected___WAsYR","noData":"TableMobile__noData___GFlfG","rowTitle":"TableMobile__rowTitle___E2yfW","customRow":"TableMobile__customRow___xdtIZ"};